<script>
    import ChalkboardSentence from './ChalkboardSentence.svelte';

    export let fontSize;
    export let sentences;

	const toggleLight = () => {
		if (document.documentElement.classList.contains('dark')) {
			document.documentElement.classList.remove('dark');
			localStorage.theme = 'light';
		} else {
			document.documentElement.classList.add('dark');
			localStorage.theme = 'dark';
		}
	}
</script>

<div class="relative">
	<div class="scene dark:brightness-[15%] transition bg-green-900 rounded-lg overflow-hidden mb-4 relative">
		<div class="chalkboard font-fuzzy-bubbles origin-left absolute flex flex-col p-4 text-white uppercase left-0 top-[-22%] w-[100%] h-[93%] overflow-hidden" style="font-size: {fontSize}px;">
			{#each sentences as sentence, i}
				<ChalkboardSentence {sentence} />
			{/each}
		</div>
		
		<img class="z-10 max-w-full block relative" src="/images/scene.png" alt="Bart">
	</div>

	<button on:click={toggleLight} class="absolute w-[3%] h-[8%] top-[36.5%] right-[22.4%]"></button>

	<a
		href="https://www.buymeacoffee.com/chrizzdf"
		target="_blank"
		title="Buy me a Coffee"
		class="h-[13.5%] flex items-center justify-center absolute z-50 right-[8%] bottom-[9%]"
	>
		<img class="max-h-full" src="/images/bmc-logo.svg" alt="Buy me a Coffee Logo">
	</a>
</div>

<style>
    .scene {
		perspective: calc(100vw + 300px);
		-webkit-perspective: calc(100vw + 300px);
		-moz-perspective: calc(100vw + 300px);
	}

	@media ( min-width: 800px ) {
		.scene {
			perspective: calc(100vw + 1200px);
			-webkit-perspective: 1200px;
			-moz-perspective: calc(100vw + 1200px);
		}
	}

	.chalkboard {
		transform-style: preserve-3d;
		transform: rotateX(1deg) rotateY(65deg);
	}
</style>